import { useCarouselImages } from "../../Hooks/layout/useCarouselImages"
import CommonImage from "../CommonCompo/CommonImage/CommonImage"
import { Calendar } from "primereact/calendar"
import CommonGrid from "../CommonCompo/CommonGrid/CommonGrid";
import { SkeletonDataTable } from "../Loader/Loader";

const CarouselImage = () => {
    const { formValue, setFormValue, files, upsertImages, handleOnchange, columns, loader } = useCarouselImages();

    return (
        <div>
            <form>
                <div className="d-flex gap-2">
                    <CommonImage type="upload" selectedImages={formValue?.files} setSelectedImages={(e) => setFormValue((prev) => ({ ...prev, files: e }))} disabled={false} is_paste={false} hideImage={true} />
                    <div className="inspectra-calendar">
                        <Calendar
                            value={formValue?.from_date}
                            onChange={handleOnchange}
                            className="input-dd w15"
                            dateFormat="dd-mm-yy"
                            minDate={new Date()}
                            name="from_date"
                            placeholder="From Date"
                        />
                    </div>
                    <div className="inspectra-calendar">
                        <Calendar
                            value={formValue?.to_date}
                            onChange={handleOnchange}
                            className="input-dd w15"
                            dateFormat="dd-mm-yy"
                            minDate={new Date()}
                            name="to_date"
                            placeholder="To Date"
                        />
                    </div>
                    <input type="number"
                        className="input-dd w20"
                        value={formValue?.order || "0"}
                        onChange={handleOnchange}
                        min={0}
                        name="order"
                        placeholder="Order"
                    />
                    <div className="mt-1">
                        <button onClick={(e) => upsertImages(e, "all")}>Upload</button>
                    </div>
                </div>
                <div>
                    {
                        formValue?.files.map((item, index) => {
                            return <>
                                {
                                    (((typeof item.carousel_image_Path === 'string') && item.carousel_image_Path?.endsWith('mp4')) || ((typeof item.file === 'object') && item.file.type?.startsWith('video'))) ? (
                                        <video
                                            src={typeof item.carousel_image_Path === 'string' || item.carousel_image_Path ? item.carousel_image_Path : URL.createObjectURL(item.file)}
                                            style={{ width: 60, height: 40 }}
                                            controls
                                        />
                                    ) : (
                                        <img
                                            src={typeof item.file === 'string' || item.carousel_image_Path ? item.carousel_image_Path : URL.createObjectURL(item.file)}
                                            alt={`Carousel ${index}`}
                                            style={{ width: 60, height: 40 }}
                                        />
                                    )}
                            </>
                        })
                    }
                </div>
            </form>
            {
                loader ? <SkeletonDataTable numSkeletons={6} /> : <CommonGrid columns={columns} data={files?.files} rowHeight={50}/>
            }
        </div>
    )
}

export default CarouselImage